import React from 'react'
import { Section, Image } from 'newComponents'
import './styles.scss'

const HomeLogos = (props) => {
  const { logos, inline } = props

  const sliceClass = inline ? 'inline' : ''

  return (
    <Section className={`home-logos ${sliceClass}`}>
      <div className="home-logos-grid">
        {logos.map((logo, index) => (
          <div className={`home-logos-item ${logo.show_on_mobile ? 'show-mobile' : ''} `} key={logo.logo_name?.text || `logo ${index}`}>
            <Image image={logo.logo_vector?.url || logo?.logo?.url} alt={logo.logo_name?.text} />
          </div>
        ))}
      </div>
    </Section>
  )
}

export default HomeLogos
